export default "__VITE_ASSET__d84d7a5e__"